import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrintRoutingModule } from './print-routing.module';
import { HttpInterceptorProviders } from 'src/app/core/interceptors';
import { ViewPrintComponent } from './view-print/view-print.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ViewPrintComponent
  ],
  imports: [
    CommonModule,
    PrintRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    HttpInterceptorProviders,
    //PrintTemplateService
  ],
})
export class PrintModule { }
